import React from 'react';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faClipboardListCheck,
  faFaceFrownSlight,
} from '@fortawesome/pro-light-svg-icons';
import { JobPosting } from './IJobs';
import DefaultLayout from '~/layouts/DefaultLayout';
import Container from '~/components/ui/Container';
import Panel from '~/components/ui/Panel';
import { Link } from '~/components/ui/Link';
import Breadcrumbs from '~/components/Breadcrumbs';

const breadcrumbLinks = [
  {
    name: 'Home',
    linkTo: '/',
  },
  {
    name: 'Over ons',
    linkTo: '/home/overons',
  },
  {
    name: 'Vacatures',
    linkTo: '/home/vacatures',
  },
];

type JobsPageProps = { 
  data: JobPosting[];
}

export const JobsPage: React.FC<JobsPageProps> = ({ data }) => (
  <DefaultLayout breadcrumbs={<Breadcrumbs links={breadcrumbLinks} />}>
    <Container state="defaultLayoutFirst" className="mb-16 md:mb-24">
      <Panel>
        <div className="text-xl lg:text-2xl font-medium font-avantgarde mb-[10px] md:mb-[24px] flex gap-3 items-center">
          <FontAwesomeIcon
            icon={faClipboardListCheck as IconProp}
            className="text-blue-500"
            fontSize={'34'}
          />
          <h1 className="panel-title--primary !mb-0">
            <span>Vacatures</span>
          </h1>
        </div>
        <h2 className="text-blue-600 font-medium font-avantgarde text-[20px]">
          Huidige vacatures
        </h2>

        {data.length > 0 ?
          (
            data?.map((item, index) => (
              <div
                className="pb-6 border-b-2 border-stone-100 last:border-0 last:pb-0 mt-5"
                key={item.id}
              >
                <h3 className="text-blue-900 font-bold font-avantgarde text-[20px] mb-[20px]">
                  {item.title}
                </h3>
                <p className="text-stone-800 font-normal font-roboto text-[16px] mb-[20px] line-clamp-3">
                  {item.text}
                </p>
                <Link
                  variant="primary"
                  href={`/home/vacatures#vacature${index + 1}`}
                >
                  Lees verder
                  <FontAwesomeIcon icon={faChevronRight as IconProp} />
                </Link>
              </div>
            ))
          ) :
          (
          <div className="w-full bg-stone-50 border-stone-200 border p-[24px] mt-[20px] rounded-lg">
            <div className="flex items-center gap-5">
              <FontAwesomeIcon
                icon={faFaceFrownSlight as IconProp}
                color="#1081D3"
                fontSize={36}
              />
              <div>
                <p className="text-[20px] font-bold font-avantgarde text-blue-600">
                  Geen openstaande vacatures
                </p>
                <p className="text-[18px] font-normal font-roboto text-blue-700">
                  Op dit moment hebben wij geen vacatures.
                </p>
              </div>
            </div>
          </div>
          )
        }
      </Panel>

      {data?.length > 0 &&
        data?.map((item, index) => (
          <Panel
            key={item.title}
            id={`vacature${index + 1}`}
          >
            <div>
              <h3 className="text-blue-900 font-bold font-avantgarde text-[20px] mb-[20px]">
                {item.title}
              </h3>
              <p className="text-stone-800 font-normal font-roboto text-[16px] mb-[20px] whitespace-pre-wrap">
                {item.text}
              </p>
            </div>
          </Panel>
        ))}
    </Container>
  </DefaultLayout>
);
